/**
 * PUT `admin/clients/:id/whatsapp` — привязать номер WhatsApp Cloud API к
 * клинике (одна привязка на клинику). По `phoneNumberId` вебхук находит
 * клинику. Секреты Meta сюда не входят — они в окружении сервиса.
 * `active: false` выключает приём вебхука, переписка остаётся.
 */

import {apiEnabled, http} from '@services/utils';

import type {WhatsAppBinding} from '../types';

export type ConnectWhatsAppInput = {id: string} & WhatsAppBinding;

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const connectWhatsApp = async ({
  id,
  ...binding
}: ConnectWhatsAppInput): Promise<WhatsAppBinding> => {
  const body = {
    phoneNumberId: binding.phoneNumberId.trim(),
    displayPhone: binding.displayPhone.trim(),
    wabaId: binding.wabaId?.trim() ? binding.wabaId.trim() : null,
    mode: binding.mode,
    active: binding.active,
  };
  if (!apiEnabled) {
    await sleep(400);
    return body;
  }
  const r = await http<Record<string, unknown>>(
    `admin/clients/${encodeURIComponent(id)}/whatsapp`,
    {method: 'PUT', body, skipCaseConversion: true},
  );
  return {
    phoneNumberId: typeof r.phoneNumberId === 'string' ? r.phoneNumberId : body.phoneNumberId,
    displayPhone: typeof r.displayPhone === 'string' ? r.displayPhone : body.displayPhone,
    wabaId: typeof r.wabaId === 'string' ? r.wabaId : null,
    mode: r.mode === 'coexistence' ? 'coexistence' : 'api_only',
    active: r.active !== false,
  };
};
